export const environment = {
  production: true,
  apiUrl: 'https://backofficeapi.zgameslatam.com/v1/api',
  apiReportsUrl: 'https://api-backoffice-reports.zgameslatam.com/v1/api',
  casinoUrl: 'https://casino-api.zgameslatam.com/v1/api',
  betResolverUrl: 'https://api-bet-resolver.zgameslatam.com/v1/api',
  fileUrl: 'https://backofficeapi.zgameslatam.com/',
  siteUrl: 'https://bet.zgameslatam.com/',
  AES_GCM_AAD: 'SortiZGames-API-v1',
  PUBLIC_KEY_FINGERPRINT: '221592350f9229fe9cb80febde06b6760109c7e91ee2d174947287096377d544',
};
